export const C_PROPERTY_ORDER_BY = {
  MOST_RECENT: {
    name: "Más reciente",
    label: "Más reciente",
    value: "-asc",
    id: 1
  },
  CITY_ASC: {
    name: "Ciudad (A–Z)",
    label: "Ciudad (A–Z)",
    value: "city-desc",
    id: 2
  },
  SECTOR_ASC: {
    name: "Sector (A–Z)",
    label: "Sector (A–Z)",
    value: "sector-desc",
    id: 3
  },
  PRICE_ASC: {
    name: "Precio: del más bajo al más alto",
    label: "Precio: del más bajo al más alto",
    value: "price-asc",
    id: 4
  },
  PRICE_DESC: {
    name: "Precio: del más alto al más bajo",
    label: "Precio: del más alto al más bajo",
    value: "price-desc",
    id: 5
  }
};

export const O_PROPERTY_ORDER_BY = {
  [C_PROPERTY_ORDER_BY.MOST_RECENT.id]: C_PROPERTY_ORDER_BY.MOST_RECENT,
  [C_PROPERTY_ORDER_BY.CITY_ASC.id]: C_PROPERTY_ORDER_BY.CITY_ASC,
  [C_PROPERTY_ORDER_BY.SECTOR_ASC.id]: C_PROPERTY_ORDER_BY.SECTOR_ASC,
  [C_PROPERTY_ORDER_BY.PRICE_ASC.id]: C_PROPERTY_ORDER_BY.PRICE_ASC,
  [C_PROPERTY_ORDER_BY.PRICE_DESC.id]: C_PROPERTY_ORDER_BY.PRICE_DESC,
  [C_PROPERTY_ORDER_BY.MOST_RECENT.value]: C_PROPERTY_ORDER_BY.MOST_RECENT,
  [C_PROPERTY_ORDER_BY.CITY_ASC.value]: C_PROPERTY_ORDER_BY.CITY_ASC,
  [C_PROPERTY_ORDER_BY.SECTOR_ASC.value]: C_PROPERTY_ORDER_BY.SECTOR_ASC,
  [C_PROPERTY_ORDER_BY.PRICE_ASC.value]: C_PROPERTY_ORDER_BY.PRICE_ASC,
  [C_PROPERTY_ORDER_BY.PRICE_DESC.value]: C_PROPERTY_ORDER_BY.PRICE_DESC
};

export const A_PROPERTY_ORDER_BY = [
  C_PROPERTY_ORDER_BY.MOST_RECENT,
  C_PROPERTY_ORDER_BY.CITY_ASC,
  C_PROPERTY_ORDER_BY.SECTOR_ASC,
  C_PROPERTY_ORDER_BY.PRICE_ASC,
  C_PROPERTY_ORDER_BY.PRICE_DESC
];
